import {Component,  Prop, Vue , Watch} from 'vue-property-decorator';
import cancelDialog from '@/theme/component/cancelOrderDialog/cancelOrderDialog.vue';
@Component({
  components: { cancelDialog }
})
export default class OrderList extends Vue {
  @Prop({type: Object, default: () => ({})})                       // 父组件状态切换
  public listStatusObj: any;
  public orderObj: any = {};                                               //  数据对象
  public apis = window.apis;
  public checkedCount: number = 0;                                         //  统计勾选的数量
  public totalInfo: any = {};                                              //  总计信息
  public isCancel: boolean = false;                                        //  删除订单弹框开关
  private totalHtml: string = '点击查看';                                   //  点击查看的内容
  private allChecked: boolean = false;                                     //  全选标志
  private orderNumbers: number[] = [];                                     //  多个订单号
  private orderNo: number = 0;

  @Watch('listStatusObj', { immediate: true, deep: true } )  //  子组件监听父组件tab切换
  public dataChange(newVal: any, oldVal: any) {
    if (newVal) {
      this.allChecked = false;
      this.orderNumbers = [];
      this.checkedCount = 0;
      this.getOrderList();
    }
  }

  public created() {

  }

  //  分页切换获取当前分页
  public getCurrentPage(page: number) {
    // this.thisOrderList = {}
    this.$emit('pageChange', page);
  }

  //  取消订单 / 查看物流信息 / 确认收货
  public option(e: any, orderInfo: any) {
    const targetClassName = e && e.target.className;
    switch (targetClassName) {
      //  查看物流信息
      case 'checkLogistics':
      case 'iMore':
        const orderNo = orderInfo.order_no;
        const details =  this.$router.resolve({name: 'orderVi', params : { orderNo }});
        window.open(details.href, '_blank');
        break;
      //  取消订单
      case 'cancel-order':
        this.isCancel = true;
        this.orderNo = orderInfo.order_no
        break;
      //  确认收货
      default:
        this.$confirm('您好！请您确认订单中全部商品已经送达您处后，再确认收货，以免遭受损失，谢谢！',
        '确认提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then( () => {
          orderInfo && this.confirmReceipt(orderInfo.delivery_order_no);
        });
    }
  }


  //  物流信息html( orderCode为父组件传入的包裹号 )
  public logisticsStatus(deliveryObj: any, order: any) {
    const orderStatus = deliveryObj.delivery_order_status;
    const packageCode = deliveryObj.delivery_package_no;
    const hoverHtml: string = `<div class="logistics-hover">
                                    <div class="iTitle">包裹号：${packageCode}</div>
                                    <div class="side-bar">
                                        <em class="circle start"></em>
                                        <em class="circle end"></em>
                                    </div>
                                    <dl class="red">
                                      <dt><em></em><span></span> </dt>
                                      <dd></dd>
                                    </dl>
                                    <dl class=""><dt><em></em><span></span></dt><dd></dd></dl>
                                    <dl><dt><em></em><div class="iMore" id="${order.orderInfo.order_no}">查看全部&gt;&gt;</div></dt></dl>
                                    <dl class=""><dt><em></em><span></span></dt><dd></dd> </dl>
                                   </div>`;
    const option: string = ( orderStatus === 5 || orderStatus === 6 || orderStatus === 7
                                          || orderStatus === 8 || orderStatus === 10 )
                             && !order.is_presell_order ? '查看物流信息' : '';
    const title: string = '';

    const optionClassName: string = 'checkLogistics';

    let status: string = '';

    switch (orderStatus) {
      case 5:
        status = '已发货';
        break;
      case 6:
        status = '部分签收';
        break;
      case 7:
        status = '已签收';
        break;
      case 8:
        status = '已拒收';
        break;
      case 10:
        status = '已清点';
        break;
    }
    return orderStatus === 1 ? ('<p>已取消</p>') :
                      option ? `<p>${status}</p><a id="${order.orderInfo.order_no}" class="${optionClassName}" href="javascript:;" title="${title}">
                               ${optionClassName === 'checkLogistics' ? option + hoverHtml : option}</a>`
                             : `<p>${status}</p>`;
  }

  //  点击查看总金额
  public checkTotal(orderCount: string|number = '170' , orderPrice: string|number = '105345.56') {
    this.fetch({
      url: this.apis.totalInfo,
      data:{
        checkoutOrderDateType: this.listStatusObj.checkoutOrderDateType
      }
    }).then((res: any) => {
      this.totalInfo = res;
      this.totalHtml = `<span><i>${this.totalInfo.total}</i>个订单；<i>${this.totalInfo.amount}</i>元</span>`;
    })
  }

  //  新增一个显隐套餐详细的开关
  public showDetail( prd: any ) {
    if (prd.hasOwnProperty('isDetailShow')) {
      prd.isDetailShow = !prd.isDetailShow;
    } else {
      this.$set(prd, 'isDetailShow', true);
    }
  }


/*订单选择(勾选框)功能*/
  //  初始化勾选框状态( 是否可选 )
  public initCheckBoxStatus(order: any) {
    const tabIndex: number = this.listStatusObj.orderTabSwitch;
    const orderInfo = order.orderInfo;
    const status = orderInfo.order_status;
    const subStatus = orderInfo.order_substatus;
    const orderActivityTag = orderInfo.hasOwnProperty('order_activity_tag') ? orderInfo.order_activity_tag : '';
    let isDisabled: boolean;
    const init = (isDisable: boolean) => {
      this.$set(order, 'isCheckAble', !isDisable);
      return isDisable;
    };
    //    所有订单tab和订单回收站tab需要多逻辑判断
    if (tabIndex === 1 || !tabIndex) {
      if (tabIndex) {
        if (this.listStatusObj.orderStatus === '2' || status === 2 || (status === 5 && subStatus === 530)) {
          isDisabled = orderActivityTag ? orderActivityTag.indexOf('21') > -1 : false;
        } else {
          isDisabled = true;
        }
      } else {
        isDisabled = orderActivityTag ? orderActivityTag.indexOf('21') > -1 : false;
      }
    } else {
      return init(tabIndex !== 2);   //  待付款和待收货tab下的勾选框状态相反
    }
    return init(isDisabled);
  }

  //  全选
  public allCheck() {
    let count: number = 0;
    this.orderObj.orders.forEach((item: any) => {
      if (item.isCheckAble) {
        if (!item.hasOwnProperty('isChecked')) {
          this.$set(item, 'isChecked', true);
        } else {
          item.isChecked = this.allChecked;
        }
        if (!this.allChecked) {
          this.checkedCount = 0;
          this.orderNumbers = [];
        } else {
          this.checkedCount = ++count ;
          this.orderNumbers.indexOf(item.orderInfo.order_no) < 0 && this.orderNumbers.push(item.orderInfo.order_no);
        }
      }
    });
  }

  //  单独选
  public singleCheck(order: any) {
    !order.hasOwnProperty('isChecked') && this.$set(order, 'isChecked', true);
    let checkAbleCount: number = 0;
    this.orderObj.orders.forEach((item: any) => {
      checkAbleCount += item.isCheckAble ? 1 : 0;
    } );
    if (order.isChecked) {
      this.checkedCount += 1;
      this.orderNumbers.push(order.orderInfo.order_no);
    } else {
      this.checkedCount += (this.checkedCount > 0 ? -1 : 0);
      const spliceIndex = this.orderNumbers.indexOf(order.orderInfo.order_no);
      this.orderNumbers.length && this.orderNumbers.splice(spliceIndex, 1);
    }
    this.allChecked = this.checkedCount === checkAbleCount;
  }


/*订单按钮操作功能*/
  //  订单支付
  public orderPay(orderNo: any ) {
    if (Object.prototype.toString.call(orderNo) === '[object Array]') {
      if (!orderNo.length) {
        this.$message('请至少选择一个订单');
        return;
      }
      orderNo = orderNo.join(',');
    }
    this.fetch({
      url: this.apis.orderPay,
      data: {
        orderIds: orderNo,
        payChannel: 'YZGPC'
      }
    }).then((data: any) => {
      if (data.payType === 2) {
         this.$router.push({
           name: 'preDepositPay',
           params: { reqNo: data.reqNo }
         });
      } else {
        window.location.href = `${data.cashierReqUrl}?reqNo=${data.reqNo}&payReqNo=${data.payReqNo}`;
      }
    })
  }

  //  删除/还原订单
  public deleteOrRestoreOrder(orderNo: any , e: any) {
    if (Object.prototype.toString.call(orderNo) === '[object Array]') {
      if (!orderNo.length) {
        this.$message('请至少选择一个订单');
        return;
      }
      orderNo = orderNo.join(',');
    }
    const {className} = e && e.target;
    const info = className === 'delete-order' ? '确认要删除所选中的订单' : '确定还原所选中的订单？';
    this.$confirm(info, '确认提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      lockScroll: false,
      type: 'warning',
    })
      .then(() => {
        this.fetch({
          url: this.apis.orderDeleteAndRestore,
          data: {
            orderNo,
            type: className === 'delete-order' ? 1 : 2
          }
        })
          .then(() => {
            this.allChecked = false;
            this.getOrderList();
          })
    })
      .catch(() => {
      })
  }

  //  确认收货
  public confirmReceipt( orderNo: number ) {
    this.fetch({
      url: this.apis.orderSign,
      data: {
        signStr: JSON.stringify([{
            deliveryOrderId: orderNo,
            checkChannel: 1,
            checkType: 1
      }])}
    }).then(() => {
      this.getOrderList();
    })
  }

  //  更新订单列表
  private getOrderList() {
    this.$emit('loaded', false);
    this.fetch({
      url: this.apis.orderList,
      data: this.listStatusObj
    }).then((data: any) => {
      this.orderObj = data;
      if (this.listStatusObj.orderDelete !== 1) {
        this.$emit('orderStatusNum', data.orderStatusNum);
      }
    }).finally(() => {
      this.$emit('loaded', true);
    });
  }
}
